import "./Search.scss";
import { MdClose } from "react-icons/md";
import prod from "../../../assets/products/watch-prod-2.webp";

const Search = ({ setShowSearch }) => {
  const handleCloseClick = () => {
    console.log("Close button clicked");
    setShowSearch(false);
  };

  return (
    <div className="search-modal">
      <div className="form-field">
        <input type="text" autoFocus placeholder="Search for products" />
        <MdClose onClick={handleCloseClick} />
      </div>
      <div className="search-result-content">
        <div className="search-results">
            <div className="search-results-item">
                <div className="img-container">
                    <img src={prod} alt="" />
                </div>
                <div className="prod-details">
                    <div className="name">Product Name</div>
                    <div className="description">Product Description</div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
